import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Compass01 = function Compass01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 12c0 5.5228-4.4772 10-10 10m10-10c0-5.5228-4.4772-10-10-10m10 10h-2m-8 10C6.4772 22 2 17.5228 2 12m10 10v-2M2 12C2 6.4772 6.4772 2 12 2M2 12h2m8-10v2m7.0711 15.0711-1.4142-1.4142M6.3432 6.3432 4.9289 4.9289m12.728 1.4143 1.4142-1.4143M4.9289 19.0711l1.4143-1.4142M8 12l2.5-1.5L12 8l1.5 2.5L16 12l-2.5 1.5L12 16l-1.5-2.5z"
    })
  }));
};
export default Compass01;